export const environment = {
  production: false,
  cognito: {
    userPoolId: 'us-west-2_wLMKbWNZd',
    userPoolWebClientId: '7li6tkofagg9stqs1om85p8rd5',
  },
  keepCashApi: {
    url: 'https://sbx-kc-alb-1623850954.us-west-2.elb.amazonaws.com',
    auth_basic: {
      user: 'core-service',
      pass: 'K33pC4sH@S3cuR3!',
    },
  },
};
